import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(8),
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  backButton: {
    color: theme.palette.text.secondary,
  },
  title: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  mainCard: {
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  sectionTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  tableContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    borderRadius: 8,
  },
  boldText: {
    fontWeight: 600,
  },
  quantityControl: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  quantityButton: {
    border: '1px solid #e0e0e0',
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      color: 'white',
    },
  },
  quantityInput: {
    width: 80,
    '& input': {
      padding: theme.spacing(1),
      textAlign: 'center',
      fontWeight: 600,
    },
  },
  subtotalValue: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  checkboxContainer: {
    marginTop: theme.spacing(2),
  },
  sideCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  sideCardTitle: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  infoItem: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  summaryCard: {
    borderRadius: 12,
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    border: '2px solid',
    borderColor: theme.palette.primary.main,
  },
  alertBox: {
    backgroundColor: '#FFF4E6',
    padding: theme.spacing(1.5),
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    border: '1px solid #FFB74D',
  },
  alertText: {
    color: '#E65100',
    fontWeight: 600,
    textAlign: 'center',
  },
  summaryItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  totalValue: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  infoBox: {
    backgroundColor: '#E8F5E9',
    padding: theme.spacing(1.5),
    borderRadius: 8,
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  instructions: {
    '& p': {
      lineHeight: 1.8,
    },
  },
  actionsCard: {
    marginTop: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    position: 'sticky',
    bottom: theme.spacing(3),
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  cancelButton: {
    textTransform: 'none',
    color: theme.palette.text.secondary,
  },
  generateButton: {
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1.5, 4),
    fontSize: 16,
  },
}));
